export default {
  mixed: {
    required: 'Ce champ est obligatoire',
    default: 'Champ invalide'
  },
  string: {
    min: ({ min }) => `Ce champ doit contenir au moins ${min} caractères`,
    max: ({ max }) => `Ce champ doit contenir au maximum ${max} caractères`,
    email: 'Veuillez saisir une adresse e-mail valide'
  },
  number: {
    min: ({ min }) => `La valeur doit être supérieure ou égale à ${min}`,
    max: ({ max }) => `La valeur doit être inférieure ou égale à ${max}`
  }
}
